module.exports = __webpack_public_path__ + "static/media/f3.88406991.jpg";